// import "babel-polyfill";
import App from "./App.vue";
// import lodash from "lodash";
import 'vue3-carousel/dist/carousel.css';
import "../src/assets/scss/main-theme.scss";
import { vfmPlugin } from "vue-final-modal";
import router from "./routes";
import { createApp } from "vue";

const app = createApp(App);

// app.config.globalProperties.lodash = lodash;

app.use(router);
app.use(vfmPlugin());

declare global {
  interface Vue {
    $gmap: any;
    window: any;
  }
}
declare global {
  interface Window {
    jQuery: any;
    $: any;
  }
}
// window.jQuery = window.$ = jQuery;

app.mount("#app");
